module.exports = __webpack_public_path__ + "static/dashboard_technology-0fe0869d32528c4419753161ad37b613.png";